import { render, staticRenderFns } from "./PriceShowText.vue?vue&type=template&id=ec43b0c0&scoped=true"
import script from "./PriceShowText.vue?vue&type=script&lang=js"
export * from "./PriceShowText.vue?vue&type=script&lang=js"
import style0 from "./PriceShowText.vue?vue&type=style&index=0&id=ec43b0c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec43b0c0",
  null
  
)

export default component.exports